import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Login from "../pages/Login";
import PrivateRoute from "./PrivateRoute";
import { ToastContainer } from "react-toastify";

export default function AppRoutes({ darkMode, setDarkMode }) {
  return (
    <BrowserRouter>
      <ToastContainer position="top-right" autoClose={1000} />
      <Routes>
        <Route
          path="/login"
          element={<Login darkMode={darkMode} setDarkMode={setDarkMode} />}
        />
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <Home darkMode={darkMode} setDarkMode={setDarkMode} />
            </PrivateRoute>
          }
        />
        <Route
          path="*"
          element={<Login darkMode={darkMode} setDarkMode={setDarkMode} />}
        />
      </Routes>
    </BrowserRouter>
  );
}
